import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WGGameConfig} from "../WGGameConfig";
import {WgShakingDisplayObject} from "../DisplayObject/WgShakingDisplayObject";
import {Sequence} from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import {Power3, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WGParsedGameData} from "../server/data/WGParsedGameData";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {WGEngineManager} from "../engine/WGEngineManager";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {WarriorGraveyardGameModuleConfig} from "../WarriorGraveyardGameModuleConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";


export class WGAnticipation extends BaseView {
    // _scatterAnticipationAnim will have 3 animations
    // at index 0->loop, 1->base , 2->Strike
    private _shakeObject: WgShakingDisplayObject;
    private _anticipationAnims: Sequence[] = [];
    private _warriorAnticipationAnim: TimelineSprite[] = [];
    private _superFsSideBorder: PIXI.Sprite[] = [];
    private _superFsSideBorderParticles: Sequence[] = [];
    private playingScatter: boolean = false;
    private firstTrigger: boolean = true;
    private tlTransition: TimelineMax | null;
    private transitionDelay: number = 0.125;
    private _landinBlast: TimelineSprite[] = [];
    // warrior anticipation stuff
    private _warriorBorderFire: TimelineSprite[][] = [];
    private _beforeBorderFirePatch: PIXI.Sprite[] = [];
    private actualReels: string[][] = [];
    public _anticipationBotttomFire: TimelineSprite[][] = [];
    private tl_WarriorAnticipationOnSymbol: TimelineMax;
    private _warriorAnticipationOnSymbolLayer: ScalableLayer;
    private _nearWarriorReels: boolean[] = [];
    private _dimmer: PIXI.Graphics;
    private _stickyWildReelsBefore: boolean[] = [];
    private _deathIsNear: PIXI.Sprite;
    public _triggerWarriorSymbol: string = "";
    public _waPlayingOnReels = [false, false, false, false, false, false];
    public _wildLandinAnimation: PIXI.spine.Spine[] = [];
    public _warriorAttackText: PIXI.Sprite;
    private warrioText_tl: TimelineMax;
    public _activeWarriorReels: boolean[] = [];
    private blastonReel: number[] = [];

    public stopDeathIsNear(): void {
        TweenLite.to(this._deathIsNear, 0.2, {alpha: 0, onComplete: () => this._deathIsNear.visible = false});
    }

    public stopWildLandingByReelId(reelId: number): void {
        TweenLite.to(this._wildLandinAnimation[reelId - 1], 0.2, {alpha: 0}).eventCallback("onComplete", () => {
            this._wildLandinAnimation[reelId - 1].visible = false;
        });
    }

    public stopAllWildLanding(): void {
        this._wildLandinAnimation.forEach(value => {
            (TweenLite.to(value, 0.2, {alpha: 0})).eventCallback("onComplete", () => {
                value.state.clearTracks();
                value.visible = false;
            });
        });
    }

    protected initAnimations(): void {
        // updated layer name to keep this above the pillar
        this.tl_WarriorAnticipationOnSymbol = new TimelineMax();
        StageManager.getLayer(WGGameConfig.instance.LAYERS.FEATURE.name).addChild(this);
        this._warriorAnticipationOnSymbolLayer = StageManager.getLayer(WGGameConfig.instance.LAYERS.STICKY_FIRE.name);
        this._shakeObject = new WgShakingDisplayObject(StageManager.stage);
        this.createSequences();
        this.createWarriorAnticipationAnimation();
        this.createSuperFsAnticipation();
        this.createBottomAnticipationFire();
        this.createAnimBordersForWholeGrid();
        this.createDeathIsNear();
        this._warriorAttackText = new PIXI.Sprite(GameResources.getTextures("WarriorAttackText")[0]);
        StageManager.getLayer(WGGameConfig.instance.LAYERS.WARRIOR_TEXT.name).addChild(this._warriorAttackText);
        this._warriorAttackText.visible = false;
        this._warriorAttackText.anchor.set(0.5);
        this._warriorAttackText.scale.set(0);
        this._warriorAttackText.position.set(360);
        this.warrioText_tl = new TimelineMax();
        for (let i: number = 0; i < 6; i++) {
            let spine = new PIXI.spine.Spine(GameResources.getSpineAsset("fs_wild_landing"));
            spine.visible = false;
            spine.pivot.set(0.5)
            this.addChild(spine);
            this._wildLandinAnimation.push(spine);
        }
    }


    public warriorTextBasedOnLevels(level: number = this.blastonReel.length): TimelineLite {
        if (WGEngineManager.isQuickStop) return new TimelineLite();

        level = (level > this.blastonReel.length) ? level : this.blastonReel.length;
        this.warrioText_tl = Helper.timeLineKiller(this.warrioText_tl, new TimelineMax({
            onComplete: () => {
                this._warriorAttackText.alpha = 1;
                this._warriorAttackText.visible = false;
            }
        }));
        const from: number = 0.25 * (level + 1), to: number = (level === 1) ? 0.7 : 0.3 * (level + 1);
        this.warrioText_tl.add(() => {
            this._warriorAttackText.visible = true;
        });
        this.warrioText_tl.fromTo(this._warriorAttackText.scale, 0.3, {x: from, y: from}, {x: to, y: to});
        this.warrioText_tl.to(this._warriorAttackText, 0.2, {alpha: 0}, this.warrioText_tl.time() + 0.5);
        return this.warrioText_tl;
    }


    public playWildLandingAnimation(reelId: number, symId: number, winConfirmed: boolean): void {
        this._wildLandinAnimation[reelId - 1].scale.set(1);
        const yOffset: number = symId < 3 ? 90 : -90;
        this._wildLandinAnimation[reelId - 1].position.set((reelId * 120) + 60, (symId * 199) + yOffset);
        this._wildLandinAnimation[reelId - 1].alpha = 0;
        const tl: TimelineMax = new TimelineMax();
        tl.timeScale(1.5);
        tl.add(new SpineTween(this._wildLandinAnimation[reelId - 1], 0, "fs_wild_landing"));
        (tl).eventCallback
        ("onComplete", () => {
            if (winConfirmed) {
                this.playWildLandingLoopInWarriorAttack(reelId - 1);
            }
        });
        TweenLite.to(this._wildLandinAnimation[reelId - 1], 0.2, {alpha: 1});
        this._wildLandinAnimation[reelId - 1].updateTransform();
        this._wildLandinAnimation[reelId - 1].visible = true;
    }

    private playWildLandingLoopInWarriorAttack(reelId: number): void {
        TweenLite.to(this._wildLandinAnimation[reelId].scale, 0.2, {y: 0.4});
        if (this._wildLandinAnimation[reelId].position.y < 400) {
            TweenLite.to(this._wildLandinAnimation[reelId].position, 0.2, {y: this._wildLandinAnimation[reelId].position.y + 10});
        }
        new SpineTween(this._wildLandinAnimation[reelId], 0, "fs_wild_landing", -1);
        TweenLite.to(this._wildLandinAnimation[reelId], 0.2, {alpha: 0.8});
    }

    private createDeathIsNear(): void {
        this._deathIsNear = new PIXI.Sprite(GameResources.getTextures("DeathIsNear")[0]);
        this._deathIsNear.visible = false;
        this._deathIsNear.anchor.set(0.5);
        this._deathIsNear.position.set(360);
        this.addChild(this._deathIsNear);
    }

    private playDeathIsNear(): void {
        this._deathIsNear.visible = true;
        this._deathIsNear.alpha = 0;
        TweenLite.to(this._deathIsNear, 0.2, {alpha: 1});
    }

    /**
     * function to create warrior anticipation
     */
    private createWarriorAnticipationAnimation(): void {
        this._warriorAnticipationAnim.push(new TimelineSprite(GameResources.getTextures("warriorAnticipationStrike"), 30));
        this._warriorAnticipationAnim[0].anchor.set(0.3, 0.5);
        this._warriorAnticipationAnim[0].position.set(120, 410);

        this._warriorAnticipationAnim.push(new TimelineSprite(GameResources.getTextures("warriorAnticipationLoop"), 30));
        this._warriorAnticipationAnim[1].anchor.set(0.3, 0.5);
        this._warriorAnticipationAnim[1].position.set(120, 410);

        this._warriorAnticipationAnim.push(new TimelineSprite(GameResources.getTextures("warriorAnticipationTopRing"), 30));
        this._warriorAnticipationAnim[2].anchor.set(0.35, 0.5);
        this._warriorAnticipationAnim[2].position.set(120, 80);

        // bottom ring copy of top
        this._warriorAnticipationAnim.push(new TimelineSprite(GameResources.getTextures("warriorAnticipationTopRing"), 30));
        this._warriorAnticipationAnim[3].anchor.set(0.35, 0);
        this._warriorAnticipationAnim[3].position.set(120, WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.HEIGHT + 55);

        this._warriorAnticipationAnim.forEach((animation: TimelineSprite) => {
            animation.blendMode = PIXI.BLEND_MODES.ADD;
            animation.visible = false;
            this.addChild(animation);
        });
    }

    public playWarrior(reelId: number): void {
        this.stopAndHideWarriorAttackAnimation();
        this._warriorAnticipationAnim[0].position.x = 120 * reelId;
        this._warriorAnticipationAnim[0].getAnimationAutoShowHide(true, true, undefined, () => {
            this._warriorAnticipationAnim.forEach((animation: TimelineSprite, index: number) => {
                if (index > 0) {
                    animation.position.x = 120 * reelId;
                    animation.visible = true;
                    animation.playLoop();
                }
            });
        });
    }

    public stopAndHideWarriorAttackAnimation(): void {
        this._warriorAnticipationAnim.forEach((animation: TimelineSprite) => {
            animation.visible = false;
            animation.stopLoop();
        });
    }

    /**
     * create background alpha
     */
    public createBackgroundDimmer(visibility: boolean): PIXI.Graphics {
        const blackAlpha = new PIXI.Graphics();
        blackAlpha.beginFill(0x000000);
        blackAlpha.drawRect(0,
            0,
            NolimitApplication.screenBounds.width,
            NolimitApplication.screenBounds.height);
        blackAlpha.alpha = 0.3;
        blackAlpha.visible = visibility;
        blackAlpha.scale.set(4);
        blackAlpha.endFill();
        StageManager.getLayer(WGGameConfig.instance.LAYERS.BACKGROUND.name).addChildAt(blackAlpha, 1);
        return blackAlpha;
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.parseData(event.params[0]));
    }

    private parseData(data: WGParsedGameData): void {
        this.actualReels = data.actualReels.filter(reel => reel.filter((value: string, index: number) => index >= 1 && index <= 3));
        this._nearWarriorReels = data.nearWinWarrior;
        this._stickyWildReelsBefore = data.lockedWildReelsBefore;
    }

    private createAnimBordersForWholeGrid(): void {
        const symbolsAndreels: number[] = [3, 7];
        for (let i = 0; i < symbolsAndreels[0]; i++) {
            this._warriorBorderFire[i] = [];
            for (let j = 0; j < symbolsAndreels[1]; j++) {
                let singleAnim = new TimelineSprite(GameResources.getTextures("WarriorAttackAnticipation_frameFire"), 20);
                singleAnim.blendMode = PIXI.BLEND_MODES.ADD;
                singleAnim.anchor.set(0.5);
                singleAnim.visible = false
                let reelId = j < 5 ? j : 5;
                singleAnim.position.set(120 * j, 199 * (i + 1));
                switch (i) {
                    case 0:
                        singleAnim.height -= 80;
                        break;
                    case 1:
                        singleAnim.height -= 80;
                        break;
                    case 2:
                        singleAnim.height -= 80;

                        break;
                }
                this._warriorAnticipationOnSymbolLayer.addChild(singleAnim);
                this._warriorBorderFire[i].push(singleAnim);
            }
        }
    }

    public litUpWarriorSymbol(symbolName: string[], tillReel: number, noBlast: boolean = false): void {
        // if (this.isWarriorPlaying(tillReel)) { // will lit up all symbols of already stopped reel
        for (let i: number = 0; i <= tillReel; i++) {
            if (this._stickyWildReelsBefore[i] || this._waPlayingOnReels[i]) {
                continue;
            }
            let firePos = -1;
            let blastpos = -1
            for (let j: number = 1; j < 4; j++) {
                const sym = this.actualReels[i][j].split("*")[0]
                if (symbolName.indexOf(sym) > -1) {
                    if (firePos < j) firePos = j;
                    if (blastpos == -1) blastpos = j;
                    this.playBorderFire(j - 1, i);
                }
            }
            if (firePos !== -1) {
                this._waPlayingOnReels[i] = true;
                const playblast = i >= this.nthIndexOf(true, 3, this._activeWarriorReels)
                    && i === tillReel && this._triggerWarriorSymbol === (this.actualReels[i][firePos].split("*")[0]);
                this.playWarriorSymbolFire(i, firePos, (playblast && !noBlast), blastpos);
            }
        }
    }

    private nthIndexOf(element: boolean, noOfindex: number, arr: boolean[]): number {
        let index = -1;
        for (let i = 0, len = arr.length; i < len; i++) {
            if (element === arr[i] && !--noOfindex) {
                index = i;
                break;
            }
        }
        return index;
    };

    private createBottomAnticipationFire(): void {
        for (let i: number = 0; i < 6; i++) {
            this._anticipationBotttomFire[i] = [];
            for (let j = 0; j < 3; j++) {
                let anim = new TimelineSprite(GameResources.getTextures("pillar_fire_Animation"), 15);
                anim.anchor.set(0.5);
                anim.scale.set(1.5);
                anim.position.set((120 * i) + 40 + (20 * j), 199);
                this._warriorAnticipationOnSymbolLayer.addChild(anim);
                if (j === 1) anim.scale.x *= -1;
                anim.visible = false;
                this._anticipationBotttomFire[i].push(anim);
            }
        }
    }

    public playBorderFire(symbolId: number, reelId: number, playAlpha: boolean = true): void {
        // warrior Border Fire
        this._warriorBorderFire[symbolId][reelId].playLoop();
        this._warriorBorderFire[symbolId][reelId].visible = true;
        this._warriorBorderFire[symbolId][reelId + 1].visible = true;
        this._warriorBorderFire[symbolId][reelId + 1].playLoop();
        if (playAlpha) {
            TweenLite.fromTo(this._warriorBorderFire[symbolId][reelId], 0.4, {alpha: 0}, {alpha: 1});
            TweenLite.fromTo(this._warriorBorderFire[symbolId][reelId + 1], 0.4, {alpha: 0}, {alpha: 1});

        }

    }

    public createFlash(reelId: number, symbolId: number): PIXI.Sprite {
        const flash = new PIXI.Sprite(GameResources.getTextures("WarriorAttackAnticipation_colorPatch")[0]);
        flash.anchor.set(0.5);
        flash.blendMode = PIXI.BLEND_MODES.ADD;
        flash.position.set((120 * reelId) + 60, 199 * symbolId);
        flash.visible = false;
        flash.tint = 0xDD0000;
        flash.mask = WGEngineManager.getReel(reelId).mask;
        this._warriorAnticipationOnSymbolLayer.addChild(flash);
        this._beforeBorderFirePatch.push(flash);
        return flash;
    }


    public getWarriorBlastAnim(reelId: number, symbolId: number): TimelineSprite {
        this.blastonReel.push(reelId);
        const blast: TimelineSprite = new TimelineSprite(GameResources.getTextures("WarriorAttackAnticipation_Blast"), 40)
        this._warriorAnticipationOnSymbolLayer.addChild(blast);
        blast.anchor.set(0.5);
        blast.scale.set(2);
        blast.visible = false;
        blast.position.set((120 * reelId) + 60, 199 * (symbolId));
        this._landinBlast.push(blast)
        return blast;
    }

    private playWarriorSymbolFire(reelId: number, symbolId: number, addBlast: boolean, blastpos?: number): void {
        const flash = this.createFlash(reelId, symbolId);
        if (addBlast && blastpos && this._nearWarriorReels[reelId]) {
            let blastFlash = this.createFlash(reelId, blastpos);
            blastFlash.tint = 0xFFDF00;
            let blast = this.getWarriorBlastAnim(reelId, blastpos);
            (reelId !== 5) && this.warriorTextBasedOnLevels(this._landinBlast.length);
            this.tl_WarriorAnticipationOnSymbol.add(() => blast.visible = true, 0);
            this.tl_WarriorAnticipationOnSymbol.add(() => blast.getAnimationAutoShowHide(true, true), 0);
            this.tl_WarriorAnticipationOnSymbol.fromTo(blastFlash, 0.1, {alpha: 0.7}, {
                alpha: 0,
                onComplete: () => blastFlash.visible = false
            });
        }

        this.tl_WarriorAnticipationOnSymbol.fromTo(flash, 0.2, {alpha: 0}, {
            alpha: 0.7, onStart: () => {
                flash.visible = true;
            }
        }, this.tl_WarriorAnticipationOnSymbol.time());
        this.tl_WarriorAnticipationOnSymbol.fromTo(flash, 0.4, {alpha: 0.7}, {alpha: 0.2}, this.tl_WarriorAnticipationOnSymbol.time() + 0.2);
        this._anticipationBotttomFire[reelId].forEach(anim => {
            anim.alpha = 0
            anim.visible = true, anim.playLoop(), anim.y = (199 * symbolId + 1) + 20;
            TweenLite.fromTo(anim, 0.4, {alpha: 0}, {alpha: 1});
        });
    }

    public hideAllWarriorFire(): void {
        this.tl_WarriorAnticipationOnSymbol.clear();
        this._waPlayingOnReels = [false, false, false, false, false, false];
        this.tl_WarriorAnticipationOnSymbol.kill();
        this._warriorBorderFire.forEach(value => value.forEach(value1 => {
            value1.stopLoop();
            value1.visible = false;
        }));

        this._anticipationBotttomFire.forEach(value => value.forEach(value1 => {
            value1.visible = false;
            value1.stopLoop();
        }));

        this._beforeBorderFirePatch.forEach(value => this._warriorAnticipationOnSymbolLayer.removeChild(value));
        this._beforeBorderFirePatch = [];

        this._landinBlast.forEach(value => this._warriorAnticipationOnSymbolLayer.removeChild(value));
        this._landinBlast = [];
        this._warriorAttackText.scale.set(0);
        this.blastonReel = [];

    }

    public stopWarriorFireByReelId(reelId: number, flashId: number, stopNextAnim: boolean): void {
        this._anticipationBotttomFire[reelId].forEach(value => {
            value.stopLoop();
            value.hide();
        });
        this._beforeBorderFirePatch.forEach(value => this._warriorAnticipationOnSymbolLayer.removeChild(value));

        this._warriorBorderFire.forEach(value => value.forEach((anim: TimelineSprite, index: number) => {
            if (index === reelId) {
                anim.stopLoop();
                anim.hide();
            }
            if (stopNextAnim && index === reelId + 1) {
                anim.stopLoop();
                anim.hide();
            }
        }));

    }

    private createSequences(): void {
        const amount: number = 4;
        for (let k: number = 0; k < amount; k++) {
            this._anticipationAnims.push(this.addChild(Sequence.createSequence()))
            this._anticipationAnims[k].blendMode = PIXI.BLEND_MODES.ADD;
            this._anticipationAnims[k].alpha = 1;
            this._anticipationAnims[k].visible = false;
        }
    }

    private defineAnimTextures(isScatter: boolean): void {
        // this.alpha = 1;
        if (isScatter && (!this.playingScatter || this.firstTrigger)) {
            this._anticipationAnims[0].setTexture(GameResources.getTextures("scatterAnticipationLoop"));
            this._anticipationAnims[0].anchor.set(0.25, 0.5);

            this._anticipationAnims[1].setTexture(GameResources.getTextures("scatterAnticipationBase"));
            this._anticipationAnims[1].anchor.set(0.3, 0.1);

            this._anticipationAnims[2].setTexture(GameResources.getTextures("scatterAnticipationStrike"));
            this._anticipationAnims[2].anchor.set(0.35, 0.5);
            this.playingScatter = true;
        } else if (!isScatter && (this.playingScatter || this.firstTrigger)) {

            this._anticipationAnims[0].setTexture(GameResources.getTextures("warriorAnticipationStrike"));
            this._anticipationAnims[0].anchor.set(0.3, 0.5);
            this._anticipationAnims[0].position.set(120, 410);

            this._anticipationAnims[1].setTexture(GameResources.getTextures("warriorAnticipationLoop"));
            this._anticipationAnims[1].anchor.set(0.3, 0.5);
            this._anticipationAnims[1].position.set(120, 410);

            this._anticipationAnims[2].setTexture(GameResources.getTextures("warriorAnticipationTopRing"));
            this._anticipationAnims[2].anchor.set(0.35, 0.5);
            this._anticipationAnims[2].position.set(120, 80);

            this._anticipationAnims[3].setTexture(GameResources.getTextures("warriorAnticipationTopRing"));
            this._anticipationAnims[3].anchor.set(0.35, 0);
            this._anticipationAnims[3].position.set(120, WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.HEIGHT + 55);
            this.playingScatter = false;
        }
        if (this.firstTrigger) this.firstTrigger = false;
    }

    private get isPlaying(): boolean {
        return this._anticipationAnims.findIndex(seq => seq.isActive) >= 0 || this._superFsSideBorder[0].visible;
    }

    private isWarriorPlaying(reelId: number): boolean {
        return ((this._nearWarriorReels.indexOf(true) - 1) === reelId);
    }

    /**
     * function to play scatter anticipation animation base on reel ID
     * @param reelId
     */
    public playScatter(reelId: number): TimelineLite {
        if (this.isPlaying) {
            this.tlTransition = Helper.timeLineKiller(this.tlTransition!, new TimelineMax({
                onComplete: () => {
                    this.stopAndHideAttentions();
                    this.playScatter(reelId);
                }
            }))
            this.tlTransition.fromTo(this, this.transitionDelay, {alpha: 1}, {alpha: 0});
            return this.tlTransition;
        } else {
            this.defineAnimTextures(true);
            this._anticipationAnims[0].position.set(120 * reelId, 195 * 2);
            this._anticipationAnims[1].position.set(120 * reelId, WGGameConfig.instance.REEL_ENGINE_CONFIG.DIM.HEIGHT);
            this._anticipationAnims[2].position.set(120 * reelId, 190 * 2);


            return this._anticipationAnims[2].playAnimation({
                onUpdate: () =>
                    this.alpha = Math.min(1, this._anticipationAnims[2].timeline!.time() / MathHelper.frameToSeconds(2.5)),
                onStart: () => {
                    this._anticipationAnims[2].visible = true;
                    this.alpha = 1;
                }
            }).add([
                () => {
                    this.alpha = 0;
                    this._shakeObject.scatterAnticipationShake(0.05, 7);
                    this._anticipationAnims[0].playAnimation({
                        repeat: -1,
                        onStart: () => this._anticipationAnims[0].visible = true
                    }),
                        this._anticipationAnims[1].playAnimation({
                            repeat: -1,
                            onStart: () => this._anticipationAnims[1].visible = true
                        })
                },
            ], MathHelper.frameToSeconds(5));

        }
    }

    /**
     * function to hide all scatter anticipation animation
     */
    public stopAndHideAttentions() {
        this._dimmer.visible = false
        this._anticipationAnims.forEach(s => {
            s.stop();
            s.visible = false;
        });

        if (this._superFsSideBorder[0].visible) {
            this._superFsSideBorder.forEach(s => s.visible = false);
            this._superFsSideBorderParticles.forEach(s => {
                s.stop();
                s.visible = false;
            });
        }
    }

    private createSuperFsAnticipation(): void {
        for (let i = 0; i < 2; i++) {
            let sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("superFsBorder")[0]);
            sprite.position.set(120 * (5 + i), 195 * 2);
            sprite.anchor.set(0.5);
            sprite.visible = false;

            this.addChild(sprite);
            this._superFsSideBorder.push(sprite);

            let tlSPrite = new Sequence({textures: GameResources.getTextures("superFsSideParticles")});
            tlSPrite.position.set(120 * (5 + i), 195 * 2);
            tlSPrite.blendMode = PIXI.BLEND_MODES.ADD;
            tlSPrite.anchor.set(0.5);
            tlSPrite.visible = false;
            this.addChild(tlSPrite);
            this._superFsSideBorderParticles.push(tlSPrite);

            let topBottomFire = new Sequence({textures: GameResources.getTextures("superFsSideTopBottomFire")});
            topBottomFire.position.set((120 * 6) - 60, i == 0 ? 185 : 185 * 3.2);
            topBottomFire.blendMode = PIXI.BLEND_MODES.ADD;
            topBottomFire.anchor.set(0.5);
            if (i == 0) {
                topBottomFire.scale.y *= -1;
            }
            topBottomFire.visible = false;
            this.addChild(topBottomFire);
            this._superFsSideBorderParticles.push(topBottomFire);
        }
    }

    /**
     * function to play super fs anticipation
     * this animation will always be played on last reel
     */
    public playSuperFsAnticipationAnimation() {
        // #144
        this.playDeathIsNear();
        this.stopAndHideAttentions();
        const reelId = 5;
        this._dimmer.visible = true;
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode: "FREESPIN"}));
        WgShakingDisplayObject.punkShake({
            x: 0.5,
            y: 2,
            duration: 0.6,
            hertz: 180 + (0.1 * 60),
            Intensity: 8 + (0.1 * 6.5),
            obj: StageManager.stage,
            positionCb: () => new PIXI.Point(0, 0),
            ease: Power3.easeOut,
            reverseEase: true
        });
        WarriorGraveyardGameModuleConfig.stickMuliplier.showReelAreaMulitplier();

        this._superFsSideBorder.forEach((anim: PIXI.Sprite) => {
            anim.visible = true;
        });

        this._superFsSideBorderParticles.forEach((anim: Sequence) => {
            anim.visible = true;
            anim.playAnimation({repeat: -1});
        });

        this._anticipationAnims[0].position.set(120 * reelId, 195 * 2);
        this._anticipationAnims[0].visible = true;
        this._anticipationAnims[0].playAnimation({repeat: -1});
    }

    protected onResize(resizeData: IResizeData): void {
        if (this._dimmer && this._dimmer.visible) {
            this._dimmer.clear();
            this._dimmer = this.createBackgroundDimmer(true);
        } else {
            this._dimmer = this.createBackgroundDimmer(false);
        }
        this._dimmer.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
    }
}